import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { CASH_DEPOSIT } from "../../../../../../utility/SourceAPI"

import {
    getDateToFilterAPI
} from "../../../../../../utility/formats/formattedDate"

export const getCashDeposit = createAsyncThunk('appCashDeposit/getCashDeposit', async (data) => {
    const response = await axios.get(data.rangeDates !== undefined ? CASH_DEPOSIT.concat(`?${getDateToFilterAPI(data.rangeDates)}`) : CASH_DEPOSIT)
    return {
        data: response.data
    }
})

export const getCashDepositIntermediary = createAsyncThunk('appCashDepositIntermediary/getCashDepositIntermediary', async (data) => {
    const response = await axios.get(data.rangeDates !== undefined ? CASH_DEPOSIT.concat(`?${getDateToFilterAPI(data.rangeDates)}&intermediary_id=${data.id}`) : CASH_DEPOSIT.concat(`?intermediary_id=${data.id}`))
    return {
        data: response.data
    }
})

export const addCashDeposit = createAsyncThunk('appCashDeposit/addCashDeposit', async (cashDeposit, { dispatch }) => {
    const response = await axios.post(CASH_DEPOSIT, cashDeposit)
    await dispatch(getCashDeposit())
    return response.data
})

export const addCashDepositCFDI = createAsyncThunk('appCashDeposit/addCashDepositCFDI', async (cashDeposit) => {
    const response = await axios.post(CASH_DEPOSIT.concat('linked-cfdi/'), cashDeposit)
    return response.data
})

export const updateCashDeposit = createAsyncThunk('appCashDeposit/updateCashDeposit', async (cashDeposit, { dispatch }) => {
    const response = await axios.put(CASH_DEPOSIT.concat(`${cashDeposit.id}`), cashDeposit)
    await dispatch(getCashDeposit())
    return response.data
})

export const deleteCashDeposit = createAsyncThunk('appCashDeposit/deleteCashDeposit', async (id, { dispatch }) => {
    const response = await axios.delete(CASH_DEPOSIT.concat(`${id}`))
    await dispatch(getCashDeposit())
    return response.data
})

export const appCashDepositSlice = createSlice({
    name: 'appCashDeposit',
    initialState: {
        data: [],
        cashDepositIntermediary: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCashDeposit.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
        builder.addCase(getCashDepositIntermediary.fulfilled, (state, action) => {
            state.cashDepositIntermediary = action.payload.data
        })
    }
})

export default appCashDepositSlice.reducer